import { Component, ViewContainerRef, OnInit, ViewEncapsulation, EventEmitter, Output, ViewChild, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipInput } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HighlightPipe } from '../../../pipes/highlight-char.pipe';

@Component({
    selector: 'app-form-input-autocomplete',
    templateUrl: './form-input-autocomplete.component.html',
    styleUrls: ['./form-input-autocomplete.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatChipGrid, MatChipRow, MatInput, MatAutocompleteTrigger, MatChipInput, MatAutocomplete, MatOption, MatError, TranslateModule, HighlightPipe]
})
export class FormInputAutocompleteComponent implements Field, OnInit, OnDestroy {
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('autoCompleteInput') autoCompleteInput: ElementRef<HTMLInputElement>;
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;
  autocompleteOptions: any[];
  selectedOptions: any = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  originalData: any[];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  fruitCtrl = new FormControl();
  toHighlight = '';
  // @Output() valueChange: EventEmitter<any> = new EventEmitter();
  selectedData: any = [];
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger }) autoCompleteSelect: MatAutocompleteTrigger;

  constructor(public _eR: ElementRef, public renderer: Renderer2) {

  }


  inputEmiter(e) {
    if (e.target.value.length > 0) {
      this.toHighlight = e.target.value;
      /* this.autocompleteOptions = this.config.autocompleteOptions; */
      this.autocompleteOptions = this.originalData.filter(option => {
        return (
          option.name.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
        );
      });
      // this.group.patchValue({toPerson:''})
    } else {
      this.autocompleteOptions = [];
    }

    // To open suggestion panel when autocomplete results are found
    if (this.autocompleteOptions.length > 1) {
      this.autoCompleteSelect.openPanel();
      console.log('Panel opened');
    }
  }

  add(event: MatChipInputEvent): void {
    // Add fruit only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      // Add our fruit
      // if ((value || '').trim()) {
      //   this.selectedOptions.push(value.trim());
      // }

      // Reset the input value
      if (input) {
        input.value = '';
        this.autocompleteOptions = [];
      }
      // this.group.patchValue({toPerson:''})
    }
  }

  ngOnInit() {
   this.FormControlName = this.config.name;
   this.originalData = this.config.autocompleteOptions;
   this.selectedOptions = this.config.value.length !== 0 ? this.config.value.filter(Boolean) : [] ;
   this.selectedData = this.config.value.length !== 0 ? this.config.value : [];
    // this.selectedOptions = this.config.value.split(",").length != 0 ? this.config.value.split(",").filter(Boolean) : [];
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const hoverData = event.option.viewValue;
    if (this.config.allowDuplicate) {
      this.addDatatochip(event);
    } else {
      const isDuplicate = this.selectedData.some((x: string) => x === hoverData);
      if (!isDuplicate) {
        this.selectedData.push(hoverData);
        this.addDatatochip(event);
        this.autocompleteOptions = [];
      }
    }
  }

  addDatatochip(event) {
    this.toHighlight = '';
    this.selectedOptions.push(event.option.viewValue);
      this.autoCompleteInput.nativeElement.value = '';
      this.group.patchValue({toPerson: this.selectedOptions});
  }

  DoCheck(): void {
    const panel = this.matAutocomplete ? this.matAutocomplete.panel : undefined;
    if (panel && panel.nativeElement.parentElement) {
     panel.nativeElement.parentElement.classList.add(this.config.panelClass);
    }
  }

  remove(index): void {
    this._eR.nativeElement.getElementsByTagName('mat-chip')[index].remove();
    this.selectedOptions.splice(index, 1);
    this.selectedData.splice(index, 1);
    const selectedId = new Set(this.selectedData.map(({ id }) => id));
    this.autocompleteOptions = this.originalData.filter(x => x.name !== this.selectedData.map(filterx => filterx));
    this.group.patchValue({toPerson: this.selectedOptions});
  }
   removeLast(event): void {
    event.target.focus();
    if (event.which === 8 && event.target.value === '') {
      const tagLenth = this._eR.nativeElement.getElementsByTagName('mat-chip').length;
      const matlistLength = this._eR.nativeElement.getElementsByTagName('mat-chip').length;
      if (matlistLength > 0 ) {
        this._eR.nativeElement.getElementsByTagName('mat-chip').item([matlistLength - 1]).remove();
        this.selectedOptions.splice((matlistLength - 1), 1);
        this.selectedData.splice((matlistLength - 1), 1);
      }

      this.autocompleteOptions = this.originalData.filter(x => x.name !== this.selectedData.map(filterx => filterx));
      event.target.focus();
    }
    if (event.target.value === '') {
      this.autocompleteOptions = [];
    }
    this.group.patchValue({toPerson: this.selectedOptions});
  }
  tapEvent(index) {
    this.removeInput();
    const newInput = this.renderer.createElement('input');
    this.renderer.setProperty(newInput, 'id', 'chipDummyInput');
    this.renderer.setProperty(newInput, 'type', 'text');
    this.renderer.setAttribute(newInput, 'autocomplete', 'off');
    this.renderer.appendChild(this._eR.nativeElement.getElementsByTagName('mat-chip')[index], newInput);
    this._eR.nativeElement.querySelector('#chipDummyInput').focus();
    this._eR.nativeElement.querySelector('#chipDummyInput').addEventListener('blur', this.removeInput.bind(this));
  }
  removeInput() {
    const removeInputElement  = this._eR.nativeElement.querySelectorAll('#chipDummyInput');
    if (removeInputElement.length > 0) {
      for (let a = 0; a < removeInputElement.length; a++) {
        setTimeout(() => {
          removeInputElement[a].remove();
        }, 1);
      }
    }
  }
  checkvalue() {
    if (this.selectedOptions.length > 0) {
      const checkOption = this.selectedOptions.filter(o1 => this.originalData.every(o2 => o1 !== o2.name));
      if (checkOption.length > 0) {
        this.config.value = '';
        this.config.showErrorText = true;
        this.group.controls[this.FormControlName].setErrors({ 'incorrect': true, 'focused': false, 'required': true });
        this.group.controls[this.FormControlName].markAsTouched();
      } else {
        this.group.controls[this.FormControlName].setErrors(null);
        this.config.showErrorText = false;
        this.config.value = this.selectedOptions;
      }

    } else {
      this.config.showErrorText = true;
    }
  }

  ngOnDestroy() {
    const chipDummyInput = this._eR.nativeElement.querySelector('#chipDummyInput');
    if (chipDummyInput) {
      chipDummyInput.removeEventListener('blur', this.removeInput.bind(this));
    }
  }






}







